import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import {
  TextChart,
  TextChartMinor,
} from "components/widgets/ScorePage/widgets/TextCharts"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import { round } from "services/units/round"
import { RETURN_OBJECTS } from "services/translations/config"
import ChartBadge from "views/atoms/badges/ChartBadge"
import ChartWithBadgeWrapperMolecule from "views/molecules/charts/ChartWithBadgeWrapperMolecule"
import ScoreChartErrorBoundary from "components/ErrorBoundary/ScoreChartErrorBoundary"

const TextChartODD13AverageEquipmentsPerFteMolecule = ({
  score,
  trendBadge,
}) => {
  if (!score?.has_workplace_equipment_inventories) {
    return <ScoreChartErrorBoundary />
  }
  const { t } = useTranslation()

  const value = round(
    score?.odd13_number_of_workplace_equipment_per_employee,
    1
  )

  const { title, help } = t(
    "analyze:it_domain.assets.equipment_per_fte",
    RETURN_OBJECTS
  )

  const badge = (
    <ChartBadge value={value} lowerLimit={2} upperLimit={3.5} inverse />
  )

  const contentVolumeEquipment = {
    kpi_text: title,
    kpi: value,
    reference: badge,
  }

  return (
    <HelpWidgetChartInteractiveMolecule text={help}>
      <ChartWithBadgeWrapperMolecule trendBadge={trendBadge} color="auto">
        <TextChart
          content={<TextChartMinor content={contentVolumeEquipment} />}
        />
      </ChartWithBadgeWrapperMolecule>
    </HelpWidgetChartInteractiveMolecule>
  )
}

TextChartODD13AverageEquipmentsPerFteMolecule.propTypes = {
  score: PropTypes.object,
  trendBadge: PropTypes.object,
}

TextChartODD13AverageEquipmentsPerFteMolecule.defaultProps = {
  trendBadge: null,
}

export default TextChartODD13AverageEquipmentsPerFteMolecule
